export const INITIAL_COURSE = { id: null, name: '' }

export const INITIAL_LICENSE = {
  licenseId: null,
  product: null,
  siteName: null,
  grades: [],
}

export const MODAL_CONTENT_TYPES = {
  Cancel: 'Cancel',
  Create: 'Create',
  Delete: 'Delete',
  Edit: 'Edit',
  HideSmallGroup: 'HideSmallGroup',
  Error: 'Error',
  ErrorDetails: 'ErrorDetails',
  Success: 'Success',
  Loading: 'Loading',
}

export const MODAL_FLOW_TYPES = {
  Create: 'Create',
  Delete: 'Delete',
  Edit: 'Edit',
  HideSmallGroup: 'HideSmallGroup',
}

export const SEPARATOR = ' | '

export const PRODUCTTEACHPAGE = '/product/middle-school/lessons'

// Small Group specific text constants
export const SMALL_GROUP_LABELS = {
  CREATE_BUTTON: 'Create Small Group',
  CLASS_NAME_LABEL: 'Small Group Name',
  DELETE_TITLE: 'Delete Small Group',
  EDIT_TITLE: 'Edit Small Group',
  SUCCESS_TITLE: 'Small Group Created',
  ERROR_TITLE: 'Error Creating Small Group',
}
